import { LegalShell, H2, P, UL } from "./LegalShell";
import { COMPANY } from "@/data/content";

export default function NDA() {
  return (
    <LegalShell
      testid="page-legal-nda"
      overline="Legal"
      title="Mutual Non-Disclosure Agreement"
      updated="Pending solicitor sign-off"
      seoDesc="TWORAY Ltd Mutual NDA v1.0 — information page and downloadable blank template."
    >
      <P>We use a Mutual Non-Disclosure Agreement (NDA) to protect confidential information exchanged between {COMPANY.name} and prospective or current clients before and during an engagement. This page summarises the NDA; a blank template is available to download (no electronic signature is offered in this version — please sign and return by email).</P>

      <H2>Key terms at a glance</H2>
      <UL items={[
        "Mutual: obligations apply equally to both parties.",
        "Purpose: information is shared solely to evaluate and deliver advisory services.",
        "Confidential information: any non-public business, technical or commercial information disclosed in any form.",
        "Exclusions: information that is public, already known, independently developed, or lawfully received from a third party.",
        "Duration: confidentiality obligations typically survive for a defined period after disclosure.",
        "No licence: disclosure does not grant any rights in the other party's intellectual property.",
      ]} />

      <H2>How to use the template</H2>
      <P>Download the blank template using the button above (print to PDF). Complete the party details, review with your legal adviser, sign, and return a copy to us. We will countersign and return a fully executed copy for your records.</P>

      <H2>Questions</H2>
      <P>If you have any questions about the NDA before signing, contact us and we'll be glad to help.</P>
    </LegalShell>
  );
}
